import * as React from 'react'
import { useEffect, useState } from 'react'
import campaignsStore from '../../../../stores/campaign_summary_amounts_store'

let listener = null

export default function JsonDataField() {
  const [amounts, setAmounts] = useState(campaignsStore.getAmounts())
  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null
    listener = campaignsStore.addListener('AmountWasChanged', () => {
      if (timeoutId) clearTimeout(timeoutId)
      timeoutId = setTimeout(() => {
        setAmounts({ ...campaignsStore.getAmounts() })
        timeoutId = null
      }, 100)
    })
    return () => {
      listener.remove()
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [])

  const itemsAttributes = []
  Object.entries(amounts).forEach(([elementId, locations]) => {
    Object.entries(locations).forEach(([locationId, amount]) => {
      const ids = campaignsStore.getIds(elementId, locationId)
      itemsAttributes.push({
        id: ids.itemId,
        location_id: parseInt(locationId, 10),
        campaign_element_id: ids.campaignElementId,
        amount,
      })
    })
  })

  return <input type="hidden" name="campaign[items_attributes]" value={JSON.stringify(itemsAttributes)} />
}
